module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-15-0130a19d1b26a5b3506c8f41acdd5ad3.jpg";